export const DEFAULT_STATE = {
  error: null,
  createEventResponse: undefined,
  createEventComplete: false,
  showSurvey: true,
  formError: false,
  options: [
    {
      label: 'Search engine',
      checked: false,
      name: 'engine',
      telemetryName: 'hearAboutJoySearch'
    },
    {
      label: 'Blog or publication',
      checked: false,
      name: 'blog',
      telemetryName: 'hearAboutJoyBlog'
    },
    {
      label: 'Wedding planner or vendor',
      checked: false,
      name: 'vendor',
      telemetryName: 'hearAboutJoyVendor'
    },
    {
      label: 'A recommendation or friend',
      checked: false,
      name: 'friend',
      telemetryName: 'hearAboutJoyRecommendation'
    },
    {
      label: 'I saw an ad',
      checked: false,
      name: 'ad',
      telemetryName: 'hearAboutJoyAd'
    },
    {
      label: 'Social media',
      checked: false,
      name: 'social',
      telemetryName: 'hearAboutJoySocialMedia'
    },
    {
      label: 'I used Joy as a guest',
      checked: false,
      name: 'guest',
      telemetryName: 'hearAboutJoyPreviousGuest'
    },
    {
      label: 'Other',
      checked: false,
      name: 'other',
      telemetryName: 'hearAboutJoyOther'
    }
  ]
};
